export function textToSlug(html) {
  const textContent = html.replace(/<[^>]*>/g, '');
  
  // Convert to slug
  return textContent
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}
